/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_User_Invitation_Requires_EnabledInputs */

const en_api_error_user_invitation_requires_enabled = /** @type {(inputs: Api_Error_User_Invitation_Requires_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable this user before resending an invitation.`)
};

const pt_br2_api_error_user_invitation_requires_enabled = /** @type {(inputs: Api_Error_User_Invitation_Requires_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ative este usuário antes de reenviar um convite.`)
};

/**
* | output |
* | --- |
* | "Enable this user before resending an invitation." |
*
* @param {Api_Error_User_Invitation_Requires_EnabledInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_user_invitation_requires_enabled = /** @type {((inputs?: Api_Error_User_Invitation_Requires_EnabledInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_User_Invitation_Requires_EnabledInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_user_invitation_requires_enabled(inputs)
	return pt_br2_api_error_user_invitation_requires_enabled(inputs)
});